<template>
  <div class="app">
    <MainNavbar />
    <router-view class="app__router-view" />
    <BottomInfoNav />
    <RightBottomButtonGroup />
  </div>
</template>

<script>
import MainNavbar from "./components/main/MainNavbar";
import BottomInfoNav from "@/parts/footer/BottomInfoNav";
import RightBottomButtonGroup from "@/parts/right-bottom-button-group/RightBottomButtonGroup.vue";
export default {
  components: {
    MainNavbar,
    BottomInfoNav,
    RightBottomButtonGroup,
  },
  // metaInfo: {
  // if no subcomponents specify a metaInfo.title, this title will be used
  // title: 'ESH | Electronic Submission Hub for Buildings Department',
  // all titles will be injected into this template
  // titleTemplate: '%s | ESH - Electronic Submission Hub for Buildings Department'
  // }
};
</script>

<style scoped lang="scss">
.app {
  background: none;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
